import debounce from "../helpers/debounce";

class Breadcrumb {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        // On page load
        self.elem.scrollLeft = self.elem.scrollWidth;

        // On window resize
        let debouncedFunction = debounce(function () {
            self.elem.scrollLeft = self.elem.scrollWidth;
        });

        window.addEventListener('resize', function () {
            debouncedFunction();
        }, false);
    }
}

export default Breadcrumb;
